import { render, staticRenderFns } from "./slide-box.vue?vue&type=template&id=c2c94ad6&scoped=true&"
import script from "./slide-box.vue?vue&type=script&lang=js&"
export * from "./slide-box.vue?vue&type=script&lang=js&"
import style0 from "./slide-box.vue?vue&type=style&index=0&id=c2c94ad6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c94ad6",
  null
  
)

export default component.exports